import * as React from 'react';
import { useUIFacade } from '../../../../../../../ui/facades/ui.facade';
import DateTemplate from '../../../../../../../ui/templates/columns/DateTemplate';
import LinkTemplate from '../../../../../../../ui/templates/columns/LinkTemplate';
import ValueTemplate from '../../../../../../../ui/templates/columns/ValueTemplate';
import PrwcDataTableAdvanced from '../../../../../../../ui/widgets/custom/PrwcDataTableAdvanced';

const LocationList = (props: any) => {

  const { onEdit } = props;
  const uiFacade = useUIFacade();

  const handleOnDelete = (rowData: any) => {
    uiFacade.showConfirmDeleteDialog(rowData, deleteLocation);
  }

  const deleteLocation = (rowData: any) => {
    console.log('delete Location --');
    console.log(rowData);
  }

  const editLocation = (rowData: any) => {
    console.log('edit Location ---');
    console.log(rowData);
    onEdit(rowData);
  }

  const data = [
    {
      id: 1000,
      name: "Location_One",
      abbreviation: "LOC",
      lastUpdated: "14/2/2020",
      description: "This is a sample text. This is a sample text."
    },
    {
      id: 1001,
      name: "Location_One",
      abbreviation: "LOC",
      lastUpdated: "14/2/2020",
      description: "This is a sample text. This is a sample text."
    },
    {
      id: 1002,
      name: "Location_One",
      abbreviation: "LOC",
      lastUpdated: "14/2/2020",
      description: "This is a sample text. This is a sample text."
    },
    {
      id: 1003,
      name: "Location_One",
      abbreviation: "LOC",
      lastUpdated: "14/2/2020",
      description: "This is a sample text. This is a sample text."
    },
    {
      id: 1004,
      name: "Location_One",
      abbreviation: "LOC",
      lastUpdated: "14/2/2020",
      description: "This is a sample text. This is a sample text."
    },
    {
      id: 1005,
      name: "Location_One",
      abbreviation: "LOC",
      lastUpdated: "14/2/2020",
      description: "This is a sample text. This is a sample text."
    },
    {
      id: 1006,
      name: "Location_One",
      abbreviation: "LOC",
      lastUpdated: "14/2/2020",
      description: "This is a sample text. This is a sample text."
    },
    {
      id: 1007,
      name: "Location_One",
      abbreviation: "LOC",
      lastUpdated: "14/2/2020",
      description: "This is a sample text. This is a sample text."
    },
    {
      id: 1008,
      name: "Location_One",
      abbreviation: "LOC",
      lastUpdated: "14/2/2020",
      description: "This is a sample text. This is a sample text."
    },
    {
      id: 1009,
      name: "Location_One",
      abbreviation: "LOC",
      lastUpdated: "14/2/2020",
      description: "This is a sample text. This is a sample text."
    },
    {
      id: 1010,
      name: "Location_One",
      abbreviation: "LOC",
      lastUpdated: "14/2/2020",
      description: "This is a sample text. This is a sample text."
    },
    {
      id: 1011,
      name: "Location_One",
      abbreviation: "LOC",
      lastUpdated: "14/2/2020",
      description: "This is a sample text. This is a sample text."
    }
  ];

  const dataTable = {
    columns: [
      {
        field: "id",
        headerLabelKey: "userCategories.label.locationId",
        bodyTemplate: LinkTemplate,
        className: "w-10 text-xs",
        sortable: true,
        command: (rowData: any) => {
          editLocation(rowData);
        }
      },
      {
        field: "name",
        headerLabelKey: "userCategories.label.locationName",
        bodyTemplate: ValueTemplate,
        className: "w-20 text-xs",
        sortable: true
      },
      {
        field: "abbreviation",
        headerLabelKey: "userCategories.label.abbreviation",
        bodyTemplate: ValueTemplate,
        className: "w-16 text-xs",
        sortable: true
      },
      {
        field: "lastUpdated",
        headerLabelKey: "userCategories.label.lastUpdated",
        bodyTemplate: DateTemplate,
        className: "w-16 text-xs",
        sortable: true
      },
      {
        field: "description",
        headerLabelKey: "userCategories.label.description",
        bodyTemplate: ValueTemplate,
        className: "w-32 text-xs",
        sortable: true
      }
    ],
  };

  return (
    <div>
      <PrwcDataTableAdvanced
        data={data}
        columns={dataTable.columns}
        paginator={true}
        onEdit={editLocation}
        onDelete={handleOnDelete}
      ></PrwcDataTableAdvanced>
    </div>
  );
};

export default LocationList;
